import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import DeactivateUserModal from './DeactivateUserModal'
import MembersListTable from './MembersListTable'

import useModalManage from '../../../../hooks/useModalManage'

import { clearUpdateMember } from '../../../../modules/actions/team'
import { updatedMemberSelector } from '../../../../modules/selectors/team'

import { MEMBER_CHANGE_STATUS } from '../../../../constants/forms'

const MembersList = ({ selfAccountName, selfAccountId }) => {
  const dispatch = useDispatch()

  const { wasUpdated: memberWasUpdated, error: updateMemberError, updatingType } = useSelector(updatedMemberSelector)

  const memberStatusWasUpdated = memberWasUpdated && updatingType === MEMBER_CHANGE_STATUS

  const {
    isModalOpened,
    closeModalHandler,
    openModalHandler: openDeactivateUserModal,
    modalData: { id: memberId }
  } = useModalManage({
    triggerClose: memberStatusWasUpdated
  })

  useEffect(() => {
    if (memberWasUpdated || updateMemberError) {
      dispatch(clearUpdateMember())
    }
  }, [dispatch, memberWasUpdated, updateMemberError])

  return (
    <>
      <MembersListTable
        selfAccountName={selfAccountName}
        selfAccountId={selfAccountId}
        openDeactivateUserModal={openDeactivateUserModal}
      />
      <DeactivateUserModal
        isModalOpened={isModalOpened}
        closeModalHandler={closeModalHandler}
        selfAccountName={selfAccountName}
        memberId={memberId}
      />
    </>
  )
}

MembersList.propTypes = {
  selfAccountId: PropTypes.number.isRequired,
  selfAccountName: PropTypes.string.isRequired
}

export default MembersList
